<template>
    <div v-if="pixError" class="align-self-center ma-2">
        <v-btn
            color="primary"
            dark
            @click="sendPixRequest()"
            :loading="pixErrorLoading"
        >
            Tentar PIX novamente
        </v-btn>
        <v-dialog
            v-model="pixErrorDialog"
            persistent
            max-width="440"
        >
            <v-card>
                <v-card-title class="text-h6" :class="pixSuccess ? 'success-title' : 'error-title'">
                    {{ dialogTitle }}
                </v-card-title>
                <v-card-text class="ma-0 py-2">{{ dialogText }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darken-1"
                        text
                        @click="reloadPage"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "RetryPixPayment",
    props: {
        booking: null,
    },
    data: () => ({
        pixErrorDialog: false,
        pixErrorLoading: false,
        pixSuccess: false,
        dialogTitle: '',
        dialogText: '',
    }),
    computed: {
        pixError() {
            return this.booking
                && this.booking.status === 'pendingPayment'
                && this.booking.payment.payment_type === 'pix'
                && this.booking.payment.transaction_id === null;
        }
    },
    methods: {
        sendPixRequest() {
            this.pixErrorLoading = true;
            axios.post(`/api/retry/pay-pix`, {booking_id: this.booking.id})
                .then((res) => {
                    this.dialogTitle = 'Agendamento PIX tentado novamente!';
                    this.dialogText = res.data.message;
                    this.pixSuccess = true;
                }).catch((err) => {
                    this.pixSuccess = false;
                    this.dialogTitle = 'Erro ao agendar PIX!';
                    this.dialogText = err.message;
                })
                .finally(() => {
                    this.pixErrorLoading = false;
                    this.pixErrorDialog = true;
                });
        },
        reloadPage() {
            window.location.reload();
        }
    },
}
</script>

<style lang="scss" scoped>
.error-title {
    background-color: #f44336;
    color: #FFF;
    width: 100%;
}

.success-title {
    background-color: #4caf50;
    color: #FFF;
    width: 100%;
}
</style>